import PropTypes from 'prop-types'
import { Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import Loader from '../../../ui/views/Loader'
import ShippingsOverview from '../../ShippingsOverview'
import EmptyStateWrapper from '../../../ui/components/EmptyState/PaperWrapper'

const LatestIncidents = ({
  tableParams,
  isLoading,
  headCells,
  rows,
  states,
  headCellsOrder,
  stepsData,
  noData,
  onClickResolveIncident,
}) => {
  const t = useTranslations()
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : noData || rows.length === 0 ? (
        <EmptyStateWrapper>
          <Typography variant="h2" className={'decorator'}>
            {t('empty:everything-goes-smoothly')}
          </Typography>
          <Typography sx={{ color: 'neutral.main' }}>
            {t('empty:no-incidents')}
          </Typography>
        </EmptyStateWrapper>
      ) : (
        <ShippingsOverview
          tableParams={tableParams}
          headCells={headCells}
          rows={rows}
          states={states}
          headCellsOrder={headCellsOrder}
          stepsData={stepsData}
          showIcon
          onClickResolveIncident={onClickResolveIncident}
        />
      )}
    </>
  )
}

LatestIncidents.propTypes = {
  tableParams: PropTypes.shape({
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    totalRows: PropTypes.number,
    sortType: PropTypes.string,
    sortColumn: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
  headCellsOrder: PropTypes.arrayOf(PropTypes.string),
  headCells: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      sortable: PropTypes.bool,
    }),
  ),
  //TODO: Review row proptypes - extract at common for reuse
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      info: PropTypes.oneOfType([
        PropTypes.shape({
          numero_colegiado: PropTypes.string,
          nombre: PropTypes.string,
          apellidos: PropTypes.string,
          modalidades: PropTypes.string,
          farmacia: PropTypes.string,
          telefono: PropTypes.string,
          correo_electronico: PropTypes.string,
        }),
        PropTypes.shape({
          nombre: PropTypes.string,
          telefono: PropTypes.string,
          correo_electronico: PropTypes.string,
          estado: PropTypes.string,
        }),
        PropTypes.shape({
          year: PropTypes.string,
          day: PropTypes.string,
          reason: PropTypes.string,
          type: PropTypes.string,
          locality: PropTypes.string,
        }),
      ]),
    }),
  ),
  states: PropTypes.array,
  stepsData: PropTypes.object,
  noData: PropTypes.bool.isRequired,
  onClickResolveIncident: PropTypes.func,
}

export default LatestIncidents
